import React, { Component, ErrorInfo } from "react";
import { Col, Row, Card } from "reactstrap";

interface ErrorBoundaryState {
  error?: string;
  errorInfo?: ErrorInfo;
  hasError: boolean;
}

export default class ErrorBoundary extends Component<{}, ErrorBoundaryState> {

  state: Readonly<ErrorBoundaryState> = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  render() {

    const { hasError, errorInfo } = this.state;

    if (hasError) {
      return (
        <Row>
          <Col>
            <Card className="p-3">
              <p>
                Sorry, something went wrong. <br></br>
                <span
                  style={{ cursor: "pointer", color: "#0077FF" }}
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Reload this page
                </span>{" "}
              </p>
              <details className="error-details">
                <summary>Click for error details</summary>
                {errorInfo && errorInfo.componentStack.toString()}
              </details>
            </Card>
          </Col>
        </Row>
      );
    }

    return this.props.children;
  }
}
